import { CheckCircle, MessageCircle, ArrowRight } from "lucide-react";

export default function PagoExitoso() {
  const handleSupportClick = () => {
    window.location.href = "/support";
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-gray-900 rounded-2xl border border-gray-800 p-8 text-center shadow-2xl">
          {/* Icon de éxito */}
          <div className="mb-6">
            <div className="mx-auto w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-500" />
            </div>
          </div>

          {/* Título */}
          <h1 className="text-2xl font-bold text-white mb-3">¡Pago Exitoso!</h1>

          {/* Mensaje principal */}
          <p className="text-gray-300 mb-8 leading-relaxed">
            Tu pago ha sido procesado correctamente. Para validar y activar tu
            plan, contáctate con nuestro soporte 24/7.
          </p>

          {/* Botón de soporte */}
          <button
            onClick={handleSupportClick}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 active:scale-95 flex items-center justify-center gap-3 shadow-lg"
          >
            <MessageCircle className="w-5 h-5" />
            Contactar Soporte
            <ArrowRight className="w-4 h-4" />
          </button>

          {/* Información adicional */}
          <div className="mt-6 pt-6 border-t border-gray-800">
            <p className="text-sm text-gray-400">
              Nuestro equipo te ayudará a activar tu plan lo antes posible
            </p>
          </div>
        </div>

        {/* Decoración de fondo */}
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-green-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/4 w-48 h-48 bg-blue-500/5 rounded-full blur-3xl"></div>
        </div>
      </div>
    </div>
  );
}
